enum AddressType {
    COMPANY_ADDRESS = 'COMPANY ADDRESS',
    MAILING_ADDRESS = 'MAILING ADDRESS'
}

export default AddressType;